function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: -2em;\n  left: 50%;\n  display: block;\n  width: 0.375em;\n  height: 1.125em;\n  margin-left: -0.1875em;\n  border-radius: 0.25em;\n  background: ", ";\n  box-shadow: 0 5.375em ", ";\n\n  &:before,\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0em;\n    left: 0em;\n    display: block;\n    width: 0.375em;\n    height: 1.125em;\n    transform: rotate(60deg);\n    transform-origin: 50% 3.25em;\n    border-radius: 0.25em;\n    background: ", ";\n    box-shadow: 0 5.375em ", ";\n  }\n\n  &:before {\n    transform: rotate(120deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import { ThemePropType, defaultTheme } from '../constants';
var Rays = styled.div.attrs({
  'data-e2e': 'rays'
})(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.raysColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.raysColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.raysColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.raysColor;
});
Rays.propTypes = {
  theme: ThemePropType
};
Rays.defaultProps = {
  theme: defaultTheme
};
Rays.displayName = 'Rays';
export default Rays;